import apiSlice from "../api/apiSlice";
import { userLoggedIn } from "./authSlice";


export const authApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login : builder.mutation({
            query: (data) => ({
                url: '/login',
                method: 'POST',
                body: data
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}){
                try{
                    const res = await queryFulfilled;
                    if (res.data.user){
                        dispatch(userLoggedIn(res.data))
                        localStorage.setItem("auth", JSON.stringify(res.data));
                    }
                }catch(err){

                }
            }
        }),
        register: builder.mutation({
            query: (data) => ({
                url: '/register',
                method: 'POST',
                body: data
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}){
                try{
                    const res = await queryFulfilled;
                    if (res.data.user){
                        dispatch(userLoggedIn(res.data))
                        localStorage.setItem("auth", JSON.stringify(res.data));
                    }
                }catch(err){

                }
            }
        })    
    })
})


export const { useLoginMutation, useRegisterMutation } = authApi;